import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-tradegroup-dropdown',
    templateUrl: './TradeGroupDropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => TradeGroupDropdownComponent) }]
})
export class TradeGroupDropdownComponent extends BaseDropdownComponent {


    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }
    tradeGroups: ent.TradeGroup[] = [];


    ngOnInit(): void {
    }

    public load() {

        var filter: filters.TradeGroupFilter = {};
        this.domainDataService.getTradeGroups(filter).subscribe(x => this.onGetTradeGroupsDone(x));
    }

    onGetTradeGroupsDone(items: ent.TradeGroup[]) {
        this.tradeGroups = items;
        this.selectItems.push({ label: "", value: Constants._NONE });
        items.forEach(y => this.selectItems.push({ label: y.FullName, value: y.ID }));

        if (this.selectedID) {
            this.value = this.selectedID;
        }
        else {
            if (this.selectDefault) {
                var defaultItems = items.filter(x => x.Code == Constants._DEFAULT_TRADE_GROUP_CODE);
                if (defaultItems.length > 0) {
                    this.value = defaultItems[0].ID;
                }
            }
        }
    }

}